class Addon {
    constructor() {
        this.closeModal = this.closeModal.bind(this),
        this.openModal = this.openModal.bind(this),
        this.addProductCard = this.addProductCard.bind(this),
        this.addVariant = this.addVariant.bind(this),
        this.removeVariant = this.removeVariant.bind(this),
        this.removeProductCard = this.removeProductCard.bind(this),
        this.addonAddToCart = this.addonAddToCart.bind(this),
        this.modals = document.querySelectorAll("[data-modal-id]"),
        this.closeButtons = document.querySelectorAll(".modal__close-button"),
        this.closeButtons.forEach(btn=>btn.onclick = this.closeModal),
        this.applyButtons = document.querySelectorAll(".addon-button__apply"),
        this.applyButtons.forEach(btn=>btn.onclick = this.closeModal),
        this.openButton = document.querySelector("#openModal"),
        this.openButton && (this.openButton.onclick = this.openModal),
        this.openCont = document.querySelector(".addon-container"),
        this.openCont && (this.openCont.onclick = this.openModal),
        this.selectedIds = [],
        this.checkBoxes = document.querySelectorAll(".addon-checkbox-2"),
        this.checkBoxes.forEach(b=>b.addEventListener("click", e=>{
            let isChecked = e.target.getAttribute("aria-checked") === "true";
            const id = e.target.dataset.id;
            isChecked ? (this.removeVariant(id),
            this.removeProductCard(id)) : (this.addProductCard(id),
            this.addVariant(id))
        }
        )),
        this.checkBoxes.forEach(b=>b.addEventListener("mouseenter", e=>{
            let isChecked = e.target.getAttribute("aria-checked") === "true";
            const id = e.target.dataset.id;
            if(isChecked){
              e.target.textContent = 'Remove';
            }
        }
        )),
        this.checkBoxes.forEach(b=>b.addEventListener("mouseleave", e=>{
            let isChecked = e.target.getAttribute("aria-checked") === "true";
            const id = e.target.dataset.id;
            if(isChecked){
              e.target.textContent = 'Added';
            }
        }
        )),
        this.allATC = document.querySelectorAll(".button--add-to-cart"),
        this.atc = document.querySelector(".button--add-to-cart"),
        this.quantityInput = document.querySelector(".quantity-selector__input")
        // this.atc.addEventListener("click", async e=>{
            
        //     e.preventDefault(),
        //     this.atc.classList.add("processing"),
        //     this.processing(),
        //     console.log(this.atc),
        //     console.log(this.atc.classList)
        //     // await this.addonAddToCart()
        // }
        // )
    }
    processing(){
      this.allATC.forEach((atc) => {
       atc.querySelector('.text').textContent = "Adding to Cart...";
      });
    }
    processDone(){
      this.allATC.forEach((atc) => {
       atc.querySelector('.text').textContent = "Add to Cart";
      });
    }
    openModal() {
        let currentVariantId = document.querySelector('.variant-selection').getAttribute('variant');
        
        this.modals.forEach(modal=>{
            modal.dataset.modalId == currentVariantId && (modal.style.display = "block",
            modal.addEventListener("click", e=>{
                modal.querySelector(".acc__modal-content").contains(e.target) || this.closeModal(e)
            }
            ))
        }
        ),
        this.toggleScrolling(!0),  this.enableMultipleProduct()
    }
    closeModal(e) {
        e.preventDefault(),
        this.modals.forEach(modal=>{
            modal.style.display = "none"
        }
        ),
        this.toggleScrolling(!1)
    }
    enableMultipleProduct(){
      // Select all elements with name="id"
      let elements = document.querySelectorAll('[name="id"]');
      
      // Loop through each element and update the name attribute
      elements.forEach(element => {
        element.setAttribute('name', 'id[]');
      });

      // elements = document.querySelectorAll('input[name^="properties["]');
      
      // elements.forEach(element => {
      //   // Get the current name attribute
      //   const currentName = element.getAttribute('name');
        
      //   // Prepend 'items[]' to the name attribute
      //   const newName = 'items[0]' + currentName;
        
      //   // Set the new name attribute
      //   element.setAttribute('name', newName);
      // });

      elements = document.querySelectorAll('input.saleboost_hidden');
      const seen = new Set();
      const toRemove = [];
      
      elements.forEach(element => {
          const value = element.value;
          if (seen.has(value)) {
              toRemove.push(element);
          } else {
              seen.add(value);
          }
      });
      
      // Remove all duplicate elements from the DOM
      toRemove.forEach(element => {
          element.parentElement.removeChild(element);
      });
    }
  
    toggleCheckBox(id) {
        this.checkBoxes.forEach(box=>{
            if (box.dataset.id == id) {
                let isChecked = box.getAttribute("aria-checked") === "true";
                box.setAttribute("aria-checked", !isChecked),
                box.classList.toggle("checked"),
                box.innerHTML = box.classList.contains("checked") ? "Added" : "Add"
            }
        }
        )
    }
    toggleScrolling(shouldDisable) {
        document.body.style.overflow = shouldDisable ? "hidden" : "unset"
        document.querySelector('html').style.overflow = shouldDisable ? "hidden" : "unset"
    }
    addVariant(id) {
        this.selectedIds.push(id),
        this.toggleCheckBox(id);
        const index = variantData.ids.indexOf(id)
    }
    removeVariant(id) {
        this.selectedIds = this.selectedIds.filter(item=>item !== id),
        this.toggleCheckBox(id)
    }
    addProductCard(id) {
        let USDollar = new Intl.NumberFormat("en-US",{
            style: "currency",
            currency: "USD"
        });
        const index = variantData.ids.indexOf(id)
          , title = variantData.titles[index]
          , price = USDollar.format(variantData.prices[index] / 100)
          , imageSrc = variantData.images[index]
          , type = variantData.types[index]
          , clone = document.getElementById("pCardTemplate").content.cloneNode(!0);

        console.log(imageSrc);
      
        clone.querySelector("#addonImg").src = imageSrc,
        clone.querySelector("#addonTitle").textContent = title,
        clone.querySelector("#addonPrice").textContent = price,
        clone.querySelector("#addonType").textContent = type;
        clone.querySelector("input").value = id;
      
        const card = clone.querySelector("[data-addon-card]");
        card.dataset.addonCard = id;
        const btn = clone.querySelector("[data-addon-id]");
        btn.dataset.addonId = id,
        document.getElementById("addonContainer").appendChild(clone),
        btn.addEventListener("click", e=>{
            const id2 = e.target.dataset.addonId;
            this.removeVariant(id2),
            this.removeProductCard(id2)
        }
        )
    }
    removeProductCard(id) {
        const card = document.querySelector(`[data-addon-card="${id}"]`);
        card ? card.remove() : console.error("Card not found")
    }
    async addonAddToCart() {
        let currentVariantId = document.querySelector('.variant-selection').getAttribute('variant');
        let formData = {
            items: this.selectedIds.map(id=>({
                id,
                quantity: 1
            }))
        };
        formData.items.push({
            id: currentVariantId,
            quantity: 1
        });
       let _this = this;
       setTimeout(function(){
          fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify(formData)
          }).then(response=>{
              response.ok && (console.log("Response Ok"));
              _this.processDone();
              window.location.href="/cart";
              // window.SLIDECART_UPDATE();
          }).catch(error=>{
              console.error("Error:", error)
          })
       },700);

    }
}
const addon = new Addon;
//# sourceMappingURL=/cdn/shop/t/15/assets/addon.js.map?v=18843415099959181491720855595
